export default {
  header: { //公共头部
    addshequn: "加入社群",
    allproduct: "全部产品",
    onproduct: "产品周边",
    lineshop: "线上商店",
    heyan: "防伪核验"
  },
  footer: {
    aboutus: "关于我们",
    business: "商务与合作",
    aftersales: "售后与服务",
    agreement: "服务条款",
    language: "简体中文"
  },
  login: {
    email: "邮箱",
    code: "验证码",
    sendcode: '发送',
    password: "密码",
    newpassword: "新密码",
    signin: "登录",
    signup: '注册',
    signout: '退出登录',
    reset: "重置密码",
    gologin: "还没有账号？",
    goreset: "忘记了密码？",
    gosignin: "已经有账号了？",
    change: "更换头像",
    save: "保存",
    nickname: "昵称",
    nicknametip: "您的昵称将显示在收藏卡上",
    cropper: "裁剪图片"
  },
  user:{
    collectioncard:"收藏卡",
    message:"消息",
    edit:"编辑资料"
  },
  content:{
    nocontent:"这里是空的...",
    download:"下载",
    cancel:"取消",
    wxqun:"微信官方社群",
    followus:"关注我们",
    whoweare:"我们是谁",
    whoweare1:"郑州蜗之壳文化传媒有限公司成立于 2019 年，是一家专注于原创可动手办研发与生产的新锐企业，凭借卓越的产品力迅速跻身国内手办品牌第一梯队。公司核心研发团队均来自国内外顶尖模型机构，拥有多年行业深耕经验与多款爆款产品打造履历，构建了从原画设计、3D 建模、涂装工程到产品摄影的全流程自主研发体系。",
    whoweare2:"2023 年，公司建成自有生产基地与模具工厂，实现了研发与生产的深度协同，大幅提升了交付效率与品控标准。2024 年初，公司率先引入行业领先的 5 轴数控雕刻机，完成了从传统铸钢工艺到高精度数控加工的技术升级，将模具精度与产品细节表现力提升至行业顶尖水平，进一步巩固了技术领先优势。未来，蜗之壳将持续以技术创新为核心驱动力，致力于为全球手办爱好者打造兼具艺术价值与把玩体验的高品质原创可动产品。",
    kaifa_ycjn:"原创机娘开发",
    kaifa_sqcp:"授权产品开发",
    kaifa_more:"更多可能...",
    wetodo:"我们做什么",
    contactus:"联系我们",
    contactus1:"蜗之壳希望与业界各领域开展合作！",
    contactus2:"如果您希望IP实体化、跨领域合作、代理零售等业务合作需求，欢迎联系我们。",
    contactusaddress:"河南省郑州经济技术开发区航海东路与经开第二十大街交汇处中兴新业港三期28号楼5层501室"
  },
  verify: {
    tip: "刮开包装盒背面防伪验证码区域输入验证码即可核验",
    verifybtn: "开始核验",
    where: "验证码在哪儿？",
    noinfo: "很抱歉，未能查到该产品的相关信息",
    firstinfo: "首次核验通过！该产品为正品！",
    nofirstinfo: "核验通过！该产品为正品！",
    nofirsttip: "非首次核验",
    firsttime: "首次核验时间：",
    cardstxt: "人拥有"
  },
  goods: {
    knowmore: "了解更多",
    buybtn: "立即购买",
    sellstatus_yushou: '预售',
    sellstatus_xianhuo: '现货',
    goodsinfo: '产品信息',
    goodsandaside: '内容物及配件',
    goodsphotos: '产品图册'
  },
  tdk: {
    home: '蜗之壳官网',
    products: '蜗之壳官网 - 全部产品',
    peripherals: '蜗之壳官网 - 产品周边',
    verify: '蜗之壳官网 - 防伪核验',
    aboutUs: '蜗之壳官网 - 加入社群',
    afterSales: '蜗之壳官网 - 售后与服务',
    agreement: '蜗之壳官网 - 服务条款',
    userCenter:'蜗之壳官网 ',
    userEdit:'蜗之壳官网 - 编辑资料',
    login:'蜗之壳官网 - 登录',
    reset:'蜗之壳官网 - 重置密码',
    signUp:'蜗之壳官网 - 注册',
    productinfo:'蜗之壳官网 - '
  }
}



// WEBPACK FOOTER //
// ./src/i18n/lang/app-zh-CN.js